import React, { useState, useEffect, Fragment } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    Tabs,
    Tab,
    Box,
    Menu,
    MenuItem,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Divider,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Panel from "./Panel";
import Report from "../Report";
import Qr from "./Qr/index";
import AdManagement from "./AdManagement";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import Logo from "../../assests/logo.png";
import { getCurrentBranchId } from "../../utils/auth";

const AdminHome = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const branchId = getCurrentBranchId();

    // Separate dropdown menu state for Display Options, Queue NR, and Settings
    const [anchorElDisplay, setAnchorElDisplay] = useState(null);
    const [anchorElQueue, setAnchorElQueue] = useState(null);
    const [anchorElSettings, setAnchorElSettings] = useState(null);

    const handleMenuOpenDisplay = (event) => {
        console.log("Opening Display Options dropdown");
        setAnchorElDisplay(event.currentTarget);
    };

    const handleMenuOpenQueue = (event) => {
        console.log("Opening Queue NR dropdown");
        setAnchorElQueue(event.currentTarget);
    };

    const handleMenuOpenSettings = (event) => {
        console.log("Opening Settings dropdown");
        setAnchorElSettings(event.currentTarget);
    };

    const handleMenuClose = () => {
        console.log("Closing dropdowns");
        setAnchorElDisplay(null);
        setAnchorElQueue(null);
        setAnchorElSettings(null);
    };

    const handleDropdownClick = (path) => {
        console.log("Display option clicked:", path);
        window.open(path, "_blank"); // Open in new tab
        handleMenuClose();
    };

    const handleDropdownClickQueueNR = (path) => {
        console.log("Queue NR option clicked:", path);
        window.open(path, "_blank"); // Open in new tab for Queue NR options
        handleMenuClose();
    };

    const handleDropdownClickSettings = (path) => {
        console.log("Settings option clicked:", path);
        window.open(path, "_blank"); // Open in new tab for Settings options
        handleMenuClose();
    };

    // Helper function to generate customer view URLs
    const getCustomerViewUrl = (ticketCode = "DEMO") => {
        return `/getticket/${ticketCode}`;
    };

    // Mapping tabs
    const tabs = [
        { label: "LIVE QUE", path: "/home/staff", newTab: true },
        // {
        //     label: "CUSTOMER CHOICE",
        //     path: "/home/customer-choice",
        //     newTab: true,
        // },
        { label: "STATS", path: "/home/panel", component: <Panel /> },
        { label: "REPORT", path: "/home/report", component: <Report /> },
        {
            label: "SETTINGS",
            dropdown: true,
            options: [
                {   label: "SERVICES",
                    path: "/home/service-management", 
                    newTab: true 
                },
                { label: "MENU",
                  path: "/home/menu-management", 
                  newTab: true 
                },
            ],
        },
        // {
        //     label: "AD MANAGEMENT",
        //     path: "/home/ad-management",
        //     component: <AdManagement />,
        // },
        {
            label: "AD DISPLAY",
            dropdown: true,
            options: [
                {
                    label: "DISPLAY AD LANDSCAPE",
                    path: `/home/display_ad_Landscape?branch_id=${branchId}`,
                },
                {
                    label: "DISPLAY AD PORTRAIT",
                    path: `/home/display_ad_potrait?branch_id=${branchId}`,
                },
                {
                    label: "DISPLAY AD CAROUSEL LANDSCAPE",
                    path: `/home/display_ad_Carousel_landscape?branch_id=${branchId}`,
                },
                {
                    label: "DISPLAY AD CAROUSEL PORTRAIT",
                    path: `/home/display_ad_Carousel_Portrait?branch_id=${branchId}`,
                },
            ],
        },
        {
            label: "DISPLAY OPTIONS",
            dropdown: true,
            options: [
                {
                    label: "DISPLAY",
                    path: `/home/display?branch_id=${branchId}`,
                },
                {
                    label: "DISPLAY AD",
                    path: `/home/display_ad?branch_id=${branchId}`,
                },
            ],
        },
        {
            label: "QR",
            path: "/home/qr",
            component: <Qr />,
        },
        {
            label: "CUSTOMER VIEW",
            path: getCustomerViewUrl("DEMO"),
            newTab: true,
            component: <Typography>Customer View Content</Typography>,
        },
    ];

    // Helper function to extract pathname from a path (remove query parameters)
    const getPathname = (path) => {
        if (!path) return '';
        return path.split('?')[0];
    };

    // Get active tab index from URL
    // Check both direct tab paths and dropdown option paths
    const activeTabIndex = tabs.findIndex((tab) => {
        // Check direct path
        if (tab.path && getPathname(tab.path) === location.pathname) {
            return true;
        }
        // Check dropdown options
        if (tab.dropdown && tab.options) {
            return tab.options.some(
                (option) => getPathname(option.path) === location.pathname
            );
        }
        return false;
    });

    useEffect(() => {
        if (activeTabIndex === -1) {
            navigate("/home/panel", { replace: true });
        }
    }, [activeTabIndex, navigate, location.pathname]);

    const handleTabChange = (event, newValue) => {
        if (tabs[newValue].newTab) {
            window.open(tabs[newValue].path, "_blank"); // Open in new tab
        } else if (!tabs[newValue].dropdown) {
            navigate(tabs[newValue].path);
        }
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };
    const handleLogout = () => {
        localStorage.removeItem("token"); // Remove the stored token
        window.location.href = "/login"; // Redirect to login or homepage
    };

    return (
        <Box>
            <AppBar position="static">
                <Toolbar sx={{ justifyContent: "space-between", overflow: "hidden" }}>
                    {isMobile ? (
                        <>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    src={Logo}
                                    alt="Logo"
                                    style={{
                                        height: "32px",
                                        marginRight: "16px",
                                        filter: "brightness(0) invert(1)", // Make logo white
                                    }}
                                />
                            </Box>
                            <IconButton
                                edge="end"
                                color="inherit"
                                onClick={toggleDrawer(true)}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Drawer
                                anchor="right"
                                open={drawerOpen}
                                onClose={toggleDrawer(false)}
                            >
                                <Box
                                    sx={{ width: 250 }}
                                    role="presentation"
                                    onClick={toggleDrawer(false)}
                                    onKeyDown={toggleDrawer(false)}
                                >
                                    <List>
                                        {tabs.map((tab, index) => {
                                            if (tab.newTab) {
                                                return (
                                                    <ListItem
                                                        button
                                                        key={index}
                                                        onClick={(e) =>
                                                            handleTabChange(
                                                                e,
                                                                index
                                                            )
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={tab.label}
                                                        />
                                                    </ListItem>
                                                );
                                            } else if (tab.dropdown) {
                                                return (
                                                    <Fragment key={index}>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={
                                                                    tab.label
                                                                }
                                                                sx={{
                                                                    fontWeight:
                                                                        "bold",
                                                                    color: "primary.main",
                                                                }}
                                                            />
                                                        </ListItem>
                                                        {tab.options.map(
                                                            (option, i) => (
                                                                <ListItem
                                                                    button
                                                                    key={`${tab.label}-${i}`}
                                                                    sx={{
                                                                        pl: 4,
                                                                    }}
                                                                    onClick={() => {
                                                                        if (tab.label === "DISPLAY OPTIONS") {
                                                                            handleDropdownClick(option.path);
                                                                        } else if (tab.label === "AD DISPLAY") {
                                                                            handleDropdownClickQueueNR(option.path);
                                                                        } else if (tab.label === "SETTINGS") {
                                                                            handleDropdownClickSettings(option.path);
                                                                        }
                                                                    }}
                                                                >
                                                                    <ListItemText
                                                                        primary={
                                                                            option.label
                                                                        }
                                                                    />
                                                                </ListItem>
                                                            )
                                                        )}
                                                    </Fragment>
                                                );
                                            } else {
                                                return (
                                                    <ListItem
                                                        button
                                                        key={index}
                                                        onClick={(e) =>
                                                            handleTabChange(
                                                                e,
                                                                index
                                                            )
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={tab.label}
                                                        />
                                                    </ListItem>
                                                );
                                            }
                                        })}
                                        <Divider sx={{ my: 1 }} />
                                        <ListItem
                                            button
                                            onClick={() => {
                                                toggleDrawer(false)();
                                                handleLogout();
                                            }}
                                            sx={{
                                                color: "error.main",
                                                "&:hover": {
                                                    backgroundColor: "error.light",
                                                    color: "white",
                                                },
                                            }}
                                        >
                                            <LogoutIcon sx={{ mr: 2 }} />
                                            <ListItemText primary="Logout" />
                                        </ListItem>
                                    </List>
                                </Box>
                            </Drawer>
                        </>
                    ) : (
                        <>
                            <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                                <img
                                    src={Logo}
                                    alt="Logo"
                                    style={{
                                        height: "32px",
                                        marginRight: "16px",
                                        filter: "brightness(0) invert(1)", // Make logo white
                                    }}
                                />
                            </Box>
                            <Tabs
                                value={
                                    activeTabIndex !== -1 ? activeTabIndex : 0
                                }
                                onChange={handleTabChange}
                                textColor="inherit"
                                indicatorColor="secondary"
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{ flexGrow: 1, flexShrink: 1, ml: 3, minWidth: 0 }}
                            >
                                {tabs.map((tab, index) =>
                                    tab.newTab ? (
                                        <Tab key={index} label={tab.label} />
                                    ) : tab.dropdown ? (
                                        <Tab
                                            key={index}
                                            label={
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                >
                                                    {tab.label}
                                                    <ArrowDropDownIcon
                                                        sx={{
                                                            ml: 0.5,
                                                            transform:
                                                                (tab.label ===
                                                                    "DISPLAY OPTIONS" &&
                                                                    Boolean(
                                                                        anchorElDisplay
                                                                    )) ||
                                                                (tab.label ===
                                                                    "AD DISPLAY" &&
                                                                    Boolean(
                                                                        anchorElQueue
                                                                    )) ||
                                                                (tab.label ===
                                                                    "SETTINGS" &&
                                                                    Boolean(
                                                                        anchorElSettings
                                                                    ))
                                                                    ? "rotate(180deg)"
                                                                    : "rotate(0deg)",
                                                            transition:
                                                                "transform 0.2s ease-in-out",
                                                        }}
                                                    />
                                                </Box>
                                            }
                                            onClick={
                                                tab.label === "DISPLAY OPTIONS"
                                                    ? handleMenuOpenDisplay
                                                    : tab.label === "AD DISPLAY"
                                                    ? handleMenuOpenQueue
                                                    : tab.label === "SETTINGS"
                                                    ? handleMenuOpenSettings
                                                    : null
                                            }
                                            sx={{
                                                "&.Mui-selected": {
                                                    backgroundColor:
                                                        (tab.label ===
                                                            "DISPLAY OPTIONS" &&
                                                            Boolean(
                                                                anchorElDisplay
                                                            )) ||
                                                        (tab.label ===
                                                            "AD DISPLAY" &&
                                                            Boolean(
                                                                anchorElQueue
                                                            )) ||
                                                        (tab.label ===
                                                            "SETTINGS" &&
                                                            Boolean(
                                                                anchorElSettings
                                                            ))
                                                            ? "rgba(255, 255, 255, 0.1)"
                                                            : "transparent",
                                                },
                                            }}
                                        />
                                    ) : (
                                        <Tab key={index} label={tab.label} />
                                    )
                                )}
                            </Tabs>
                        </>
                    )}

                    {!isMobile && (
                        <Typography
                            sx={{
                                mr: 2,
                                color: "#FFFF",
                                fontWeight: "bold",
                                cursor: "pointer",
                                flexShrink: 0,
                                whiteSpace: "nowrap",
                                "&:hover": { textDecoration: "underline" },
                            }}
                            onClick={handleLogout}
                        >
                            Logout
                        </Typography>
                    )}
                </Toolbar>
            </AppBar>

            {/* Dropdown Menus (desktop only) */}
            <Menu
                anchorEl={anchorElDisplay}
                open={Boolean(anchorElDisplay)}
                onClose={handleMenuClose}
                PaperProps={{
                    sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                    },
                }}
            >
                {tabs
                    .find((tab) => tab.label === "DISPLAY OPTIONS")
                    ?.options.map((option, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => handleDropdownClick(option.path)}
                            sx={{
                                "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "white",
                                },
                            }}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
            </Menu>

            {/* Dropdown Menu for "AD DISPLAY" */}
            <Menu
                anchorEl={anchorElQueue}
                open={Boolean(anchorElQueue)}
                onClose={handleMenuClose}
                PaperProps={{
                    sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                    },
                }}
            >
                {tabs
                    .find((tab) => tab.label === "AD DISPLAY")
                    ?.options.map((option, index) => (
                        <MenuItem
                            key={index}
                            onClick={() =>
                                handleDropdownClickQueueNR(option.path)
                            }
                            sx={{
                                "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "white",
                                },
                            }}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
            </Menu>

            {/* Dropdown Menu for "SETTINGS" */}
            <Menu
                anchorEl={anchorElSettings}
                open={Boolean(anchorElSettings)}
                onClose={handleMenuClose}
                PaperProps={{
                    sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                    },
                }}
            >
                {tabs
                    .find((tab) => tab.label === "SETTINGS")
                    ?.options.map((option, index) => (
                        <MenuItem
                            key={index}
                            onClick={() =>
                                handleDropdownClickSettings(option.path)
                            }
                            sx={{
                                "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "white",
                                },
                            }}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
            </Menu>

            {/* Content Area */}
            <Box sx={{ p: 3, height: "calc(100vh - 64px)", overflow: "auto" }}>
                {tabs[activeTabIndex]?.component || <Panel />}
            </Box>
        </Box>
    );
};

export default AdminHome;
